import { render, staticRenderFns } from "./AutoDividendHistory.vue?vue&type=template&id=025fcbc2&scoped=true"
import script from "./AutoDividendHistory.vue?vue&type=script&lang=js"
export * from "./AutoDividendHistory.vue?vue&type=script&lang=js"
import style0 from "./AutoDividendHistory.vue?vue&type=style&index=0&id=025fcbc2&prod&lang=scss&scoped=true"
import style1 from "./AutoDividendHistory.vue?vue&type=style&index=1&id=025fcbc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025fcbc2",
  null
  
)

export default component.exports